import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

/**
 * Back Button Controller
 *
 * A reusable controller for handling back navigation with a fallback path
 *
 * Usage:
 * <a href="#" data-controller="back-button" data-back-button-fallback-value="/some/path" data-action="click->back-button#goBack">
 *   Back
 * </a>
 */
export default class extends Controller {
  static values = {
    fallback: String
  }

  goBack(event) {
    event.preventDefault()

    const fallback = this.defaultedFallback()
    const shouldUseFallback = this.shouldUseFallback()

    if (!shouldUseFallback && window.history.length > 1) {
      window.history.back()
      return
    }

    // OLD: naive history-based fallback
    // if (window.history.length > 1) {
    //   window.history.back()
    // } else {
    //   visit(this.fallbackValue || "/")
    // }

    visit(fallback)
  }

  shouldUseFallback() {
    const fallback = this.defaultedFallback()
    const referrer = document.referrer

    if (!referrer) {
      return window.history.length <= 1
    }

    try {
      const refUrl = new URL(referrer)
      const previousPath = refUrl.pathname
      const currentPath = window.location.pathname

      if (refUrl.origin !== window.location.origin) {
        return true
      }

      if (previousPath === currentPath) {
        return true
      }

      if (["/login", "/sessions/new"].includes(previousPath)) {
        return true
      }

      if (previousPath === "/profile" && currentPath === "/profile") {
        return true
      }

      if (previousPath === fallback) {
        return true
      }

      return false
    } catch (_error) {
      return true
    }
  }

  defaultedFallback() {
    const fallback = this.fallbackValue || "/"

    // OLD: fallback defaulted inside goBack/shouldUseFallback
    // return this.fallbackValue || "/"

    return fallback
  }
}
